import { render, staticRenderFns } from "./serveOrderView.vue?vue&type=template&id=73b5defc&scoped=true&"
import script from "./serveOrderView.vue?vue&type=script&lang=js&"
export * from "./serveOrderView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b5defc",
  null
  
)

export default component.exports